import React, { useState, useEffect, createContext } from 'react';

export const MediaContext = createContext();

// TODO replace with variable
const queries = {
    isMobile: 'screen and (max-width: 480px), screen and (max-device-width: 480px)'
};

/**
 * * Global context for fetching current screen type (dependant on window width).
 * ! Use only when you need to alter the code significantly between screen sizes, otherwise use CSS.
 * TODO: Use same variable declaration between MediaContext queries and SASS variables.
 * @param {children} Node 
 */

export const MediaContextProvider = ({ children }) => {
    const [media, setMedia] = useState({
        isMobile: false,
    });

    const handleResize = () => {
        const updatedMedia = {};

        for (const [key, value] of Object.entries(queries)) {
            updatedMedia[key] = window.matchMedia(value).matches;
        }

        setMedia({ ...updatedMedia });
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);

        // run once initially
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []); // eslint-disable-line

    const contextValue = {
        ...media
    };

    return (
        <MediaContext.Provider value={contextValue}>
            {children}
        </MediaContext.Provider>
    );
};



// WEBPACK FOOTER //
// ./src/core/contexts/MediaContext.js